<app-background-card
  title="{{ 'common.selecthor.admin.customer.list.title' | transloco }}"
  titleTestId="customer-list-header"
  testId="customer-list-card"
>
  @if (customersResource.isLoading()) {
    <app-loading data-testid="customer-list-loading" />
  } @else {
    @if (hasCustomers()) {
      <p-table
        #dt
        data-testid="customer-list-table"
        [value]="customers()"
        dataKey="tenantId"
        [rows]="10"
        [paginator]="true"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'common.table.currentPageReportTemplate' | transloco }}"
        [responsiveLayout]="'scroll'"
        [globalFilterFields]="globalFilterFields"
        [sortField]="sortField()"
        [sortOrder]="sortOrder()"
        (onSort)="onSort($event)"
        [expandedRowKeys]="expandedRows()"
        [tableStyle]="{'min-width': '80rem'}"
        class="p-datatable-striped"
      >
        <ng-template #caption>
          <div class="flex justify-between items-center">
            <app-table-expand-controls (expandAll)="expandAll()" (collapseAll)="collapseAll()" />
            <app-global-search
              testId="customer-list-search"
              (searchValue)="dt.filterGlobal($event, 'contains')"
            />
          </div>
        </ng-template>

        <ng-template #header>
          <tr>
            <th style="width: 4rem" scope="col"></th>
            <th
              pSortableColumn="companyName"
              data-testid="customer-name-header"
              style="width: 12%"
              scope="col"
            >
              {{ 'selecthorAdmin.customerList.customerCompanyName' | transloco }}
              <p-sortIcon field="companyName" />
            </th>
            <th
              pSortableColumn="adminLastName"
              data-testid="admin-name-header"
              style="width: 10%"
              scope="col"
            >
              {{ 'selecthorAdmin.customerList.adminName' | transloco }}
              <p-sortIcon field="adminLastName" />
            </th>
            <th
              pSortableColumn="adminEmail"
              data-testid="admin-email-header"
              style="width: 14%"
              scope="col"
            >
              {{ 'selecthorAdmin.customerList.adminEmail' | transloco }}
              <p-sortIcon field="adminEmail" />
            </th>
            <th style="width: 12%" scope="col">
              {{ 'selecthorAdmin.customerList.adminEmailVerification' | transloco }}
            </th>
            <th pSortableColumn="status" data-testid="status-header" style="width: 8%" scope="col">
              {{ 'selecthorAdmin.customerList.status' | transloco }}
              <p-sortIcon field="status" />
            </th>
            <th
              pSortableColumn="contractStartDate"
              data-testid="contract-start-header"
              style="width: 12%"
              scope="col"
            >
              {{ 'selecthorAdmin.customerList.contractStart' | transloco }}
              <p-sortIcon field="contractStartDate" />
            </th>
            <th
              pSortableColumn="contractEndDate"
              data-testid="contract-end-header"
              style="width: 12%"
              scope="col"
            >
              {{ 'selecthorAdmin.customerList.contractEnd' | transloco }}
              <p-sortIcon field="contractEndDate" />
            </th>
            <th data-testid="payment-plan-header" style="width: 14%" scope="col">
              {{ 'selecthorAdmin.customerList.paymentPlan' | transloco }}
            </th>
            <th pSortableColumn="paid" data-testid="paid-header" style="width: 8%" scope="col">
              {{ 'selecthorAdmin.customerList.paid' | transloco }}
              <p-sortIcon field="paid" />
            </th>
            <th data-testid="invoice-data-header" style="width: 10%" scope="col">
              {{ 'selecthorAdmin.customerList.invoiceData' | transloco }}
            </th>
          </tr>
        </ng-template>

        <ng-template #body let-customer let-expanded="expanded">
          <tr data-testid="customer-list-row">
            <td>
              <p-button
                type="button"
                data-testid="row-toggle-btn"
                [pRowToggler]="customer"
                [text]="true"
                [rounded]="true"
                [plain]="true"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
              />
            </td>
            <td>
              <span class="font-medium">{{ customer.companyName }}</span>
            </td>
            <td>{{ customer.adminFirstName }} {{ customer.adminLastName }}</td>
            <td>
              <a
                [href]="'mailto:' + customer.adminEmail"
                class="text-secondary hover:text-secondary/80"
              >
                {{ customer.adminEmail }}
              </a>
            </td>
            <td class="text-center">
              <div class="flex justify-center items-center">
                @if (customer.adminEmailVerified) {
                  <p-button
                    icon="pi pi-check-circle text-green-500"
                    [label]="'selecthorAdmin.customerList.adminEmailVerified' | transloco"
                    severity="secondary"
                    size="small"
                    [disabled]="true"
                  />
                } @else {
                  <p-button
                    icon="pi pi-times-circle text-red-500"
                    [label]="'selecthorAdmin.customerList.adminEmailVerifiedResend' | transloco"
                    severity="secondary"
                    size="small"
                    (onClick)="confirmResendVerificationEmail(customer)"
                  />
                }
              </div>
            </td>
            <td class="text-center">
              @if (customer.status) {
                <p-tag data-testid="status-tag" severity="success" value="Active" />
              } @else {
                <p-tag data-testid="status-tag" severity="danger" value="Inactive" />
              }
            </td>
            <td>
              <div class="min-w-[180px]">
                <p-datepicker
                  data-testid="contract-start-date"
                  [ngModel]="customer.contractStartDate"
                  (ngModelChange)="onContractDateChange(customer, 'contractStartDate', $event)"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  [iconDisplay]="'input'"
                  [disabled]="saving()"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  class="w-full"
                ></p-datepicker>
              </div>
            </td>
            <td>
              <div class="min-w-[180px]">
                <p-datepicker
                  data-testid="contract-end-date"
                  [ngModel]="customer.contractEndDate"
                  (ngModelChange)="onContractDateChange(customer, 'contractEndDate', $event)"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  [iconDisplay]="'input'"
                  [disabled]="saving()"
                  [appendTo]="'body'"
                  [showButtonBar]="true"
                  [minDate]="customer.contractStartDate ?? undefined"
                  class="w-full"
                  [ngClass]="{
                    'ng-invalid ng-dirty': isEndDateBeforeStartDate(customer),
                  }"
                ></p-datepicker>
              </div>
            </td>
            <td>
              <div class="min-w-[160px]" data-testid="payment-plan-cell">
                <app-payment-plan-select
                  [ngModel]="customer.paymentPlanDirectusId"
                  (ngModelChange)="onPaymentPlanChange(customer, $event)"
                  [placeholder]="'selecthorAdmin.customerList.selectPaymentPlan' | transloco"
                  [disabled]="saving()"
                  [appendTo]="'body'"
                  [showClear]="true"
                  [showMonthLength]="false"
                  [preloadedPlans]="paymentPlans()"
                  [includeRetiredPlans]="true"
                />
              </div>
            </td>
            <td class="text-center">
              <div class="flex justify-center items-center">
                <p-checkbox
                  data-testid="paid-checkbox"
                  [ngModel]="customer.paid"
                  (ngModelChange)="onPaidStatusChange(customer, $event)"
                  [binary]="true"
                  [disabled]="saving()"
                />
              </div>
            </td>
            <td class="text-center">
              <div class="flex justify-center items-center">
                <p-button
                  icon="pi pi-eye"
                  data-testid="view-invoice-data-btn"
                  [pTooltip]="'selecthorAdmin.customerList.viewInvoiceData' | transloco"
                  severity="secondary"
                  size="small"
                  (onClick)="viewInvoiceData(customer)"
                  [disabled]="!customer.invoiceData"
                />
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template #expandedrow let-customer>
          <tr>
            <td colspan="11" class="p-0">
              <div
                class="ml-12 mr-4 mt-2 mb-4 px-6 py-4 bg-second-level rounded-lg border-l-4 border-primary"
              >
                <div class="flex items-stretch gap-4">
                  <div class="flex flex-col items-center justify-center gap-2 min-w-[100px]">
                    <h5
                      data-testid="features-section-label"
                      class="text-sm font-semibold uppercase tracking-wider opacity-70 whitespace-nowrap"
                    >
                      {{ 'selecthorAdmin.customerList.features' | transloco }}
                    </h5>
                    <button
                      type="button"
                      [attr.data-testid]="'features-dialog-' + customer.tenantId"
                      class="flex items-center justify-center rounded-full bg-primary w-9 h-9 hover:bg-primary/90 transition-all hover:scale-105"
                      (click)="selectFeatures(customer)"
                    >
                      <i class="pi pi-plus" style="font-size: 0.875rem; font-weight: bold"></i>
                    </button>
                  </div>

                  <div class="grow min-w-0 border-l border-surface-700 pl-4 flex items-center">
                    @if (getCustomerFunctionsDisplayWithTooltipData(customer).length > 0) {
                      <div class="flex flex-wrap gap-2" data-testid="module-function-badges">
                        @for (
                          moduleInfo of getCustomerFunctionsDisplayWithTooltipData(customer);
                          track moduleInfo.moduleName
                        ) {
                          <span
                            [pTooltip]="tooltipTemplate"
                            [tooltipStyleClass]="'large-tooltip'"
                            tooltipPosition="top"
                            class="module-function-tooltip px-3 py-1.5 bg-third-level rounded-md text-xs font-medium shadow-xs hover:shadow-sm transition-all cursor-pointer"
                          >
                            {{ moduleInfo.moduleName }} ({{ moduleInfo.count }})

                            <ng-template #tooltipTemplate>
                              <div class="custom-tooltip-content">
                                {{ moduleInfo.functionNames.join(', ') }}
                              </div>
                            </ng-template>
                          </span>
                        }
                      </div>
                    } @else {
                      <p class="text-sm text-gray-500 italic">
                        {{ 'selecthorAdmin.customerList.noFeatures' | transloco }}
                      </p>
                    }
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template #emptymessage>
          <tr>
            <td colspan="11" class="text-center py-4">
              {{ 'common.noDataAvailable' | transloco }}
            </td>
          </tr>
        </ng-template>
      </p-table>

      @if (shouldShowSaveButton()) {
        <div class="flex justify-end gap-2 mt-6">
          <p-button
            appConfirmStepLeaveDirective
            data-testid="save-changes-button"
            [label]="'common.save' | transloco"
            (onClick)="saveAllChanges()"
            [loading]="saving()"
            [disabled]="saving()"
            styleClass="px-8! text-sm! uppercase"
          ></p-button>
        </div>
      }
    } @else {
      <app-no-data
        icon="pi pi-users"
        label="selecthorAdmin.customerList.emptyListText"
        testId="empty-customer-list"
        textTestId="empty-customer-list-text"
      />
    }
  }

  <app-function-selection-dialog
    [visible]="dialogStateService.dialogVisible()"
    [label]="dialogStateService.currentEntityName()"
    (visibleChange)="$event ? null : dialogStateService.closeDialog()"
    (selectedFunctions)="onFeaturesSelected($event)"
    [initialSelectedFunctions]="getSelectedFeaturesForDialog()"
    [translationPrefix]="dialogTranslationPrefix"
  ></app-function-selection-dialog>

  <app-invoice-data-dialog
    [(visible)]="invoiceDialogVisible"
    [invoiceData]="selectedCustomerInvoiceData()"
  ></app-invoice-data-dialog>
</app-background-card>
